<template>
  <v-content>
    <v-container @keyup.enter='login' class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-container>
                <v-toolbar-title>Company Admin Login</v-toolbar-title>
              </v-container>
              <v-spacer />
            </v-toolbar>
            <v-container>
              <v-card-text>
                <v-alert
                dense
                v-for="(v, k) in errors"
                :key="k"
                outlined
                type="error"
                >{{ k }} {{ v }}</v-alert>
                <v-alert dense outlined v-if="successmessage !== null" type="success">{{ successmessage }}</v-alert>
                <v-form ref="form">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Email"
                    name="email"
                    prepend-icon="email"
                    type="email"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" text @click="login">Go to Login</v-btn>
                <v-spacer />
                <v-btn color="primary" @click="sendLink">Send link</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { FORGOT_PASSWORD } from "@/store/actions.type";
import { mapState } from "vuex";
export default {
  name: "ForgotPassword",
  data() {
    return {
      valid: false,
      email: "",
      emailRules: [v => /.+@.+/.test(v) || "Invalid Email address"],
      successmessage: null,
    };
  },
  methods: {
    sendLink: function() {
        this.successmessage = null
      if (this.$refs.form.validate()) {
          let email = this.email;
        this.$store
          .dispatch(FORGOT_PASSWORD, { email })
          .then(resp => {
              if(resp.success){
                  this.successmessage = resp.message
              }
          });
      }
    },
    login(){
        this.$router.push("/login")
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.autherrors
    }),
    isAuthenticated : function(){ return this.$store.getters.isAuthenticated}  
  },
  created(){
    if(this.isAuthenticated){
      this.$router.push("/learningcenter")
    }    
  }
};
</script>
